// src/components/individualcomp/CompetitionDetails.jsx
import React from 'react';

const STATUS_CONFIG = {
  draft:    { text: "This competition isn't open for submissions yet.", colour: "#EE3844", bg: "#EE384410", border: "#EE384440" },
  judging:  { text: "Submissions are closed. Judging is underway.",     colour: "#FFC324", bg: "#FFC32410", border: "#FFC32440" },
  closed:   { text: "This competition has closed.",                      colour: "#9CA3AF", bg: "#9CA3AF10", border: "#9CA3AF40" },
  archived: { text: "This competition has ended.",                       colour: "#9CA3AF", bg: "#9CA3AF08", border: "#9CA3AF30" },
};

const CompetitionDetails = ({ competition }) => {
  const { title, description, prizes, rules, status } = competition;
  const statusConfig = STATUS_CONFIG[status];

  return (
    <section className="pt-9">

      {statusConfig && (
        <div style={{
          background: statusConfig.bg,
          border: `1px solid ${statusConfig.border}`,
          borderLeft: `3px solid ${statusConfig.colour}`,
          borderRadius: "8px",
          padding: "12px 16px",
          marginBottom: "28px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}>
          <span style={{ color: statusConfig.colour, fontSize: "16px", flexShrink: 0 }}>◈</span>
          <p style={{
            color: statusConfig.colour,
            fontSize: "13px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 500,
            margin: 0,
            letterSpacing: "0.01em",
          }}>
            {statusConfig.text}
          </p>
        </div>
      )}

      <div className="mb-9">
        <h1 className="text-3xl text-imperial-red font-extrabold font-poppins">
          {title || 'Untitled Competition'}
        </h1>
      </div>

      <div className="mb-5">
        <h2 className="text-xl text-swan font-bold font-poppins mb-2">Description</h2>
        <p className="text-base text-field-grey leading-relaxed font-poppins">
          {description || 'No description has been provided yet.'}
        </p>
      </div>

      {rules && (
        <div className="mb-5">
          <h3 className="text-xl text-swan font-semibold font-poppins mb-2">Rules</h3>
          <p className="text-base text-field-grey leading-relaxed font-poppins whitespace-pre-wrap">
            {rules}
          </p>
        </div>
      )}

      <div className="mb-5">
        <h3 className="text-xl text-white font-semibold font-poppins mb-2">Prizes</h3>
        <p className="text-base text-field-grey leading-relaxed font-poppins whitespace-pre-wrap">
          {prizes || 'No prizes have been announced yet.'}
        </p>
      </div>

    </section>
  );
};

export default CompetitionDetails;